import type { ReactElement } from "react";
import * as React from "react";

export default function GlassdoorIcon(props: React.SVGProps<any>): ReactElement {
  return (
    <svg width="1em" height="1em" viewBox="0 0 667 667" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M666.667 333.667C666.667 517.763 517.428 667 333.333 667 149.24 667 0 517.763 0 333.667 0 149.572 149.239.333 333.333.333c184.095 0 333.334 149.239 333.334 333.334"
          fill="#31AF40"
          fillRule="nonzero"
        />
        <path
          d="M421.672 480.899h-235.57c0 32.525 26.367 58.892 58.893 58.892h176.677c32.525 0 58.893-26.367 58.893-58.892V239.06a2.146 2.146 0 0 0-2.146-2.145h-54.602c-1.184 0-2.145.96-2.145 2.145v241.839zm0-353.356c32.525 0 58.893 26.366 58.893 58.892h-235.57v241.838a2.147 2.147 0 0 1-2.146 2.147h-54.602a2.147 2.147 0 0 1-2.146-2.147V186.435c0-32.526 26.368-58.892 58.894-58.892h176.677z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}
